import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

const Login = () => {
    const [hame, setname] = useState('');
    const [email, setmail] = useState('');
    const [pass, setpass] = useState('');
    const [flag, setflag] = useState(false);
    const login = async (e) => {
        e.preventDefault();
        const data = { hame, email, pass };
        let resp = await fetch("http://localhost:9000/api/login",
            {
                method: "post",
                body: JSON.stringify(data),
                headers: { 'Content-type': "application/json" }
            })
        if (resp.ok) {
            let res = await resp.json();
            if (res.statuscode === 1) {
                sessionStorage.setItem("udata", JSON.stringify(res.udata))
                alert("Success login");
            } else {
                alert("fail");
            }
        }
    }

    const nav = useNavigate('');

    return (
        <>


            <div className="box mt-5">
                <div className="formt mt-1">
                    <form onSubmit={login}  method="POSTS">
                        <ul>
                            <li>
                                {
                                    flag ?
                                        <input type="text" onChange={(e) => setname(e.target.value)} placeholder="Your Name" />
                                        :
                                        <input type="text" onChange={(e) => setmail(e.target.value)} placeholder="Email" />
                                }
                            </li>
                            <br />
                            <li> <input type="password" onChange={(e) => setpass(e.target.value)} placeholder="Password" /> </li> <br />

                            {
                                flag ?
                                    <p onClick={() => setflag(false)}> login with email instead </p>
                                    :
                                    <p onClick={() => setflag(true)}> login with username instead </p>
                            }
 {/*
                            <li>
                                    <div class="h-captcha" data-sitekey='0d8003fe-9576-4db2-8b0e-0f38c568a07c'></div>
                                    <script src="https://js.hcaptcha.com/1/api.js" async defer></script>
                            </li>

                             */}
                            <li>  <button type="submit"> Login </button> </li>

                            <p onClick={() => nav("/signup")}> new user? clich here to register </p>
                        </ul>
                    </form>
                </div>
            </div>


        </>
    )
}

export default Login;